import { iaRa, inRn, mString } from 'lib/helpers/utility';
import { useUIContext } from 'lib/context/UIContext/UIContext';

import Dot from 'components/shared/Dot/Dot';
import Typography from 'components/shared/Typography/Typography';

import { summarizeInvoices } from '../lib/helpers';

import AmountItem from './AmountItem';
import PaidStatus from './InvoiceDetails/PaidStatus';

const BalanceSummary = ({ externalInvoice, invoices, amountDue }) => {
  const invoiceValues = summarizeInvoices(iaRa(invoices));
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  return (
    <div className="flex flex-col items-start gap-4 rounded-none border-0 border-t border-dashed border-t-neutral-300 px-6 py-5 sm:px-2">
      <div className="flex w-full items-start justify-between gap-2">
        <Typography variant="h5" className="sm:text-sm">
          Your balance
        </Typography>
        {externalInvoice?.paid && <PaidStatus />}
      </div>
      <div className="flex w-full items-start justify-between gap-3 sm:items-end">
        <div className="flex flex-wrap items-center gap-2 sm:flex-col sm:items-start">
          <AmountItem label="Copay" value={inRn(invoiceValues?.coPay)} />
          <Dot size="xs" color="neutral" className="sm:hidden" />
          <AmountItem label="Coinsurance" value={inRn(invoiceValues?.coInsurance)} />
          <Dot size="xs" color="neutral" className="sm:hidden" />
          <AmountItem label="Deductible" value={inRn(invoiceValues?.deductible)} />
          <Dot size="xs" color="neutral" className="sm:hidden" />
          <AmountItem
            label={isMobile ? 'Adj. & disc.' : 'Adjustments & discounts'}
            value={inRn(invoiceValues?.discount) + inRn(invoiceValues?.patientAdjustments)}
          />
        </div>
        <div className="flex flex-col items-end">
          <Typography variant="p" size="small" color="neutral-700">
            Amount due
          </Typography>
          <Typography variant="h2" weight="semibold" className="sm:text-[28px] sm:leading-9">
            {mString(inRn(amountDue))}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default BalanceSummary;
